import { TFreshRecipeQuantities } from "@api-clients/subscriptions";
import { Mandatory } from "@utils/types";

import { TraySize } from "@/constants/products";
import {
  CatGender,
  CatActivityLevel,
  CatBodyType,
  CatBreed,
  Allergen,
  CatMedicalCondition,
  SubscriptionStatus,
  PricingPlan,
  CatLifeStage,
  CatSuppressionReason,
} from "@/primary-models";

export enum SubscriptionFilter {
  HAS_FRESH = "HAS_FRESH",
  DOES_NOT_HAVE_FRESH = "DOES_NOT_HAVE_FRESH",
  NO_FILTER = "NO_FILTER",
}

export interface ICatAge {
  years?: number;
  months?: number;
  weeks?: number;
}

export interface ICatNameAndId {
  id: number;
  name: string;
}

export interface IBasicCatInfo extends ICatNameAndId {
  gender: CatGender;
  cxNotes: string | null;
  suppressionReason: CatSuppressionReason | null;
  suppressedAt: Date | null;
}

export interface ICatDetails {
  breed: CatBreed | null;
  birthday: Date | null;
  isBirthdayPrecise: boolean | null;
  bodyType: CatBodyType | null;
  lifestyle: CatActivityLevel | null;
  isNeutered: boolean | null;
  weightGrams: number | null;
  allergies: Allergen[] | null;
  medicalConditions: CatMedicalCondition[] | null;
}

export interface IExtendedCatDetails extends Mandatory<IBasicCatInfo, "name" | "gender">, ICatDetails {
  legacyCatId: string | null;
  lifeStage: CatLifeStage | null;
  kittenGccfNumber: number | null;
  breederSubId: string | null;
}

export interface ICatSubscription {
  subscriptionId: number;
  status: SubscriptionStatus;
  pricingPlan: PricingPlan;
  frequency: number;
  quantity: number;
  traySize: TraySize;
  suggestedTraySize: TraySize | null;
  calories: number | null;
  suggestedCalorieAmount: number | null;
  price: number;
  deliveryCost: number;
  recipes: TFreshRecipeQuantities | null;
  firstDeliveryDate: Date | null;
  cancellationReason: string | null;
  legacyId: number | null;
}

export interface ICatSubscriptionRecord {
  details: IExtendedCatDetails
  subscription: ICatSubscription | null;
}

export interface IGetCustomerCatsResponse {
  cats: ICatSubscriptionRecord[]
}

export interface IGetCustomerCatsParams {
  filterSubscription?: SubscriptionFilter;
  showSuppressedCats?: boolean;
}

export interface ISuppressCatRequest {
  catId: number;
  suppressionReason: CatSuppressionReason;
}
